export const API_CONSTANTS = {
  UPI_SWITCH_BASE_URL: 'https://api.lincpay.com/switch/v2',
  IMPS_BASE_URL: 'https://api.lincpay.in/v3/imps',
  BBPS_BILLS_BASE_URL: 'https://api.lincpay.com/v1/bills',
} as const;
